import axios from "axios";
import router from "../router";
import { Message } from "element-ui";

import qs from "qs";

let instance = axios.create({
  timeout: 15000,
});

const exitSystem = () => {
  setTimeout(() => {
    const login = "/login";
    localStorage.clear();
    if (router.currentRoute.fullPath !== login) {
      router.replace("/login");
    }
  }, 1000);
}
// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    // 上传文件 无需序列化
    // if (config.method === "post") {
    //   config.data = qs.stringify(config.data);
    // }

    if (config.method === "get") {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      };
    }

    let token = localStorage.getItem("token");

    if (token) {
      config.headers["token"] = `${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 响应拦截器即异常处理
instance.interceptors.response.use(
  (response) => {
    if (Number(response.data.error_no) === 401) {
      Message({
        type: 'warning',
        message: `登录状态已过期，请重新登录`
      })
      exitSystem()
    } else {
      return response.data;
    }
  },
  (err) => {
    // console.log(err, 'response')
    Message({
      type: 'warning',
      message: err.message
    })
    // exitSystem()
    return Promise.reject(err.response);
  }
);

export default instance;
